import React, { useState } from 'react';
import imageService from '../../services/ImageServie';

const na = (v) => (v === null || v === undefined || v === '' ? 'N/A' : v);
const formatDate = (d) => (d ? new Date(d).toLocaleDateString() : 'N/A');

const AdvertisementTable = ({ advertisements, onExport, exporting, onSearch, onFilter, filters = {}, appliedSearch = {}, onEdit }) => {
    const [searchTerm, setSearchTerm] = useState(appliedSearch.term || '');
    const [searchBy, setSearchBy] = useState(appliedSearch.by || '');

    const searchOptions = [
        { value: 'companyName', label: 'Company Name' },
        { value: 'phone', label: 'Phone' },
        { value: 'city', label: 'City' },
        { value: 'state', label: 'State' },
        { value: 'country', label: 'Country' },
        { value: 'email', label: 'Email' },
        { value: 'website', label: 'Website' },
        { value: 'shopType', label: 'Shop Type' },
    ];

    const handleFilterChange = (key, value) => {
        onFilter({ [key]: value });
    };

    return (
        <section className='dashboard_table_column'>
            <div className="container">
                <div className='row'>
                    <div className="col-md-12 d-flex justify-content-between align-items-center flex-wrap mb-3 px-3 data_search_input">
                        <div className="d-flex gap-2 mb-2">
                            <select
                                className="form-select"
                                style={{ width: 'auto' }}
                                value={filters.active || ''}
                                onChange={(e) => handleFilterChange('active', e.target.value)}
                            >
                                <option value="">All Status</option>
                                <option value="true">Active</option>
                                <option value="false">Inactive</option>
                            </select>
                            <select
                                className="form-select"
                                style={{ width: 'auto' }}
                                value={filters.adType || ''}
                                onChange={(e) => handleFilterChange('adType', e.target.value)}
                            >
                                <option value="">All Types</option>
                                <option value="free">Free</option>
                                <option value="paid">Paid</option>
                            </select>
                            <select
                                className="form-select"
                                style={{ width: 'auto' }}
                                value={filters.planStatus || ''}
                                onChange={(e) => handleFilterChange('planStatus', e.target.value)}
                            >
                                <option value="">All Plan Status</option>
                                <option value="active">Active</option>
                                <option value="expired">Expired</option>
                            </select>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <div className="input-group" style={{ maxWidth: '450px' }}>
                                <select
                                    className="form-select"
                                    value={searchBy}
                                    onChange={(e) => setSearchBy(e.target.value)}
                                    style={{ maxWidth: '160px' }}
                                >
                                    <option value="">Search By</option>
                                    {searchOptions.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Search Term"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    disabled={!searchBy}
                                />
                                <button
                                    className="btn btn-warning"
                                    onClick={() => onSearch(searchTerm, searchBy)}
                                    disabled={!searchBy}
                                >
                                    <i className="fa-solid fa-magnifying-glass"></i>
                                </button>
                            </div>
                            <button
                                className="btn btn-success ms-2 d-inline-flex align-items-center"
                                style={{ height: '38px', whiteSpace: 'nowrap' }}
                                onClick={onExport}
                                disabled={exporting}
                            >
                                {exporting ? (
                                    <><span className="spinner-border spinner-border-sm"></span> Exporting...</>
                                ) : (
                                    <><i className="fa-solid fa-file-export"></i> Export</>
                                )}
                            </button>
                        </div>
                    </div>

                    <div className='col-md-12 px-3'>
                        <div className='table_data_manage table-responsive'>
                            <table className="compact-table table-bordered table-hover">
                                <thead className='table-light'>
                                    <tr>
                                        <th>Id</th>
                                        <th>Actions</th>
                                        <th>Image</th>
                                        <th>Image Path</th>
                                        <th>Company</th>
                                        <th>Plan</th>
                                        <th>AD Type</th>
                                        <th>Plan Status</th>
                                        <th>Amount</th>
                                        <th>Payment</th>
                                        <th>Start Date</th>
                                        <th>End Date</th>
                                        <th>City</th>
                                        <th>Status</th>
                                        <th>Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {advertisements.length > 0 ? (
                                        advertisements.map(ad => (
                                            <tr key={ad.id}>
                                                <td>{ad.id}</td>
                                                <td className='action_btn'>
                                                    <button className="btn p-0" onClick={() => onEdit(ad)}>
                                                        <i className="fa-solid fa-pen-to-square"></i>
                                                    </button>
                                                </td>
                                                <td>
                                                    {ad.imageName ? (
                                                        <a href={`${imageService.getAdsImage}${ad.imageName}`} target="_blank" rel="noreferrer">
                                                            <img
                                                                src={`${imageService.getAdsImage}${ad.imageName}`}
                                                                alt={ad.companyName}
                                                                style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '4px' }}
                                                            />
                                                        </a>
                                                    ) : 'N/A'}
                                                </td>
                                                <td>
                                                    {ad.imageName ? (
                                                        <div style={{ fontSize: '11px', wordBreak: 'break-all', width: '200px', whiteSpace: 'normal' }}>
                                                            {`${imageService.getAdsImage}${ad.imageName}`}
                                                        </div>
                                                    ) : 'N/A'}
                                                </td>
                                                <td>{na(ad.companyName)}</td>
                                                <td>{na(ad.planName)}</td>
                                                <td>{ad.adType === 'paid' ? 'Paid' : 'Free'}</td>
                                                <td>
                                                    {ad.adType === 'paid' ? (
                                                        <span style={{
                                                            backgroundColor: ad.planStatus === 'expired' ? '#dc3545' : '#198754',
                                                            color: '#fff',
                                                            fontSize: '12px',
                                                            borderRadius: '3px',
                                                            display: 'block',
                                                            padding: '5px 12px',
                                                        }}>
                                                            {ad.planStatus === 'expired' ? 'Expired' : 'Active'}
                                                        </span>
                                                    ) : 'N/A'}
                                                </td>
                                                <td>{ad.amount ?? 'N/A'}</td>
                                                <td>{ad.paymentCycle === 'yearly' ? 'Yearly' : ad.paymentCycle === 'monthly' ? 'Monthly' : 'N/A'}</td>
                                                <td>{formatDate(ad.startDate)}</td>
                                                <td>{formatDate(ad.endDate)}</td>
                                                <td>{na(ad.city)}</td>
                                                <td>
                                                    <span style={{
                                                        backgroundColor: ad.active ? '#198754' : '#6c757d',
                                                        color: '#fff',
                                                        fontSize: '12px',
                                                        borderRadius: '3px',
                                                        display: 'block',
                                                        padding: '5px 12px',
                                                    }}>
                                                        {ad.active ? 'Active' : 'Inactive'}
                                                    </span>
                                                </td>
                                                <td>{formatDate(ad.createdDate)}</td>
                                            </tr>
                                        ))) : (
                                        <tr>
                                            <td colSpan="15" className="text-center">No data available</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AdvertisementTable;
